import { shopify } from './shopify.js';
import { error } from './notification.js';
import { TYPES } from './types.js';

const getStoreHours = function () {
	const arr = [];

	for (const _store in window.Solver.stores) {
		const s = window.Solver.stores[_store];
		const container = document.querySelector(`[data-store="${s.id}"]`);

		if (!container) return;
		const timezone = window.Solver.timezones.find((t) => t.abbr === s.timezone);
		const year = dayjs().format('YYYY');
		const month = dayjs().format('MM');
		const currentDay = dayjs().format('dddd');
		const formatting = 'YYYY-MM-DDTHH:mm:ss';
		const now = parseInt(dayjs().tz(timezone.utc[0]).format('HH'));
		const todaysHours = s.hours[currentDay];

		const _convert12To24 = (time12h) => {
			const [time, modifier] = time12h.split(' ');

			let [hours, minutes] = time.split(':');

			if (hours === '12') {
				hours = '00';
			}

			if (modifier === 'PM' || modifier === 'pm') {
				hours = parseInt(hours, 10) + 12;
			}

			return `${hours}:${minutes}`;
		};

		const opening24 = _convert12To24(`${todaysHours.opening_hour} ${todaysHours.opening_am_pm}`);
		const closing24 = _convert12To24(`${todaysHours.closing_hour} ${todaysHours.closing_am_pm}`);
		const openingHour = parseInt(dayjs(`${year}-${month}-01T${opening24}:00`).format('HH'));
		const closingHour = parseInt(dayjs(`${year}-${month}-01T${closing24}:00`).format('HH'));
		const _isOpen = () => {
			if (now >= openingHour && now < closingHour) return true;
			return false;
		};

		const hours = {
			id: s.id,
			hours: todaysHours,
			isOpen: _isOpen(),
			timezone: timezone
		};

		arr.push(hours);
	}

	return arr;
};

const isOpenUI = function (stores) {
	if (!stores || (stores && !stores.length)) return;

	stores.forEach((store) => {
		if (!store.isOpen) return;

		const tag = document.querySelector(`[data-el="is-open-${store.id}"]`);
		if (!tag) return;

		tag.classList.add('store__details-is-open--active');
	});
};

export const store = async function () {
	let _stores = getStoreHours();
	isOpenUI(_stores);
};
